import { Injectable } from '@angular/core';
import { MapGeocoder } from '@angular/google-maps';

import { firstValueFrom } from 'rxjs';

import { Address } from '../../../../Domain/Model/address';
import { GeocodingService } from '../../../../Domain/Port/geocoding.service';
import { GoogleGeocodingResultToAddressMapperService } from './Mapper/google-geocoding-result-to-address-mapper.service';

@Injectable({
    providedIn: 'root'
})
export class GoogleGeocodingService extends GeocodingService {
    constructor(
        private readonly mapper: GoogleGeocodingResultToAddressMapperService,
        private readonly geocoder: MapGeocoder
    ) {
        super();
    }

    override async getAddressesByCoordinates(lat: number, lng: number): Promise<Address[]> {
        const response = await firstValueFrom(this.geocoder.geocode({ location: { lat, lng } }));
        return this.mapper.map(response);
    }
}
